import TermsUpdateForm from './terms-update-form'

export default TermsUpdateForm;